import { Badge, Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Styles from "../../styles/_global/Styles";

function LinkTab(props) {
  const navigate = useNavigate();
  const handleTabChange = (event) => {
    event.preventDefault();
    navigate(props.href);
  };

  return <Tab onClick={handleTabChange} {...props} />;
}

export default function NavTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  const [showNewBadge, setShowNewBadge] = useState(false);
  const [hideBadge, setHideBadge] = useState(false); // For exit animation

  // Check if the badge has been dismissed
  useEffect(() => {
    const hasSeenOffers = localStorage.getItem("hasSeenOffers") === "true";
    setShowNewBadge(!hasSeenOffers);
  }, []);

  const tabs = [
    { label: "My Credit Profile", href: "/credit-profile" },
    { label: "My Special Offers", href: "/offers" },
  ];

  const currentTab = tabs.findIndex((tab) =>
    location.pathname.includes(tab.href)
  );

  const handleChange = (event, newValue) => {
    const selectedTab = tabs[newValue];

    if (selectedTab.href === "/offers") {
      // Trigger the exit animation before hiding the badge
      setHideBadge(true);
      setTimeout(() => {
        localStorage.setItem("hasSeenOffers", "true");
        setShowNewBadge(false);
        setHideBadge(false); // Reset for reappearance if needed
      }, 300); // Match the animation duration
    }

    navigate(selectedTab.href);
  };

  return (
    <Tabs
      value={currentTab === -1 ? 0 : currentTab}
      onChange={handleChange}
      aria-label="navigation tabs"
      centered
      sx={{
        ...Styles.Header.Menu.sx,
        margin: 0, // No margins
        padding: 0, // No padding
        lineHeight: 0, // Eliminate font-related spacing
        boxSizing: "border-box", // Prevent padding/border issues
        position: "relative", // Support slight downward shift
        bottom: -1, // Move tabs down to align border with header
        borderBottom: "1px solid grey.300", // Border to match header
        "& .MuiTabs-flexContainer": {
          gap: 0.5, // Space between tabs
        },
        "& .MuiTab-root": {
          position: "relative", // Support zIndex layering
          borderLeft: "1px solid",
          borderTop: "1px solid",
          borderRight: "1px solid",
          borderBottom: "1px solid", // No bottom border for inactive tabs
          borderColor: {
            xs: "rgba(255,255,255,0.01)",
            lg: "#eee",
          }, // Lighter border for inactive tabs
          borderRadius: "8px 8px 0 0", // Rounded top corners
          margin: '0 !important', // Remove any default margins
          padding: "8px 24px", // Adjust padding for tab size
          minHeight: "48px", // Consistent height
          textTransform: "none", // Preserve text case
          fontWeight: 500,
          color: {
            xs: "rgba(255, 255, 255, 0.6)",
            lg: "#777",
          }, // Darker gray for inactive tabs
          bgcolor: {
            xs: "rgba(255, 255, 255, 0.1)",
            lg: "#fff",
          }, // Slightly transparent background
          backdropFilter: "blur(10px)",
          "&.Mui-selected": {
            borderLeft: "1px solid",
            borderTop: "1px solid",
            borderRight: "1px solid",
            borderColor: {
              xs: "rgba(255, 255, 255, 0.1)",
              lg: "#e6e6e6",
            }, // Lighter border for selected tab
            borderBottom: {
              xs: "3px solid",
              lg: "1px solid"
            },
            borderBottomColor: {
              xs: "#20ae94 !important",
              lg: "white !important"
            },
            backdropFilter: "blur(10px)",
            marginBottom: -2, // Pull border further over header’s border
            zIndex: 2, // Ensure border is above header
            bgcolor: "rgba(255, 255, 255, 0.3)", // White background for selected tab
            color: {
              xs: "#fff", // White text for selected tab on mobile
              lg: "#20ae94", // Green/teal text for selected tab on desktop
            }, // Green/teal text for selected tab
          },
          "&:hover": {
            bgcolor: {
            xs: "rgba(255, 255, 255, 0.25)",
            lg: "grey.100",
          },
          },
        },
        "& .MuiTabs-indicator": {
          display: "none",
        },
      }}
    >
      {tabs.map((tab, index) => (
        <LinkTab
          key={index}
          label={
            tab.href === "/offers" && showNewBadge ? (
              <Box sx={{ position: "relative", display: "inline-block" }}>
                <Badge
                  badgeContent="NEW"
                  color="error"
                  sx={{
                    "& .MuiBadge-badge": {
                      fontSize: "0.6rem",
                      top: "-8px", // Default for larger screens
                      right: "-8px",
                      transform: "translate(50%, -50%)",
                      animation: !hideBadge
                        ? "bounce 1.5s infinite" // Bounce animation
                        : "fadeOut 0.3s forwards", // Exit animation
                      "@media (max-width: 600px)": {
                        top: "-15px", // Center on mobile
                        right: "50%",
                        left: "50%",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        borderRadius: "3px",
                        fontSize: "0.6rem",
                        width: "50px",
                        transform: "translate(-50%, -50%)",
                        zoom: 0.5,
                      },
                    },
                  }}
                >
                  {tab.label}
                </Badge>
              </Box>
            ) : (
              tab.label
            )
          }
          href={tab.href}
          disableRipple
        />
      ))}
    </Tabs>
  );
}